import imgAboutMe from "../assets/img/me/me_photo.jpg"

export const ImgDataMe = [{
    id: 1,
    img: imgAboutMe
}]